<template> 
<div :class="{mobile_selfAuth:isMobile}">  
    <div class="page_title_center">
        <h1>본인인증</h1>
        <span>상품구매를 위한 절차이며, 휴대폰 & 이메일 중 한가지방법으로 인증 하시면 됩니다.</span>
    </div>
    <div class="self_auth">
        <div class="pblock" :class="{invalid: !name.isValid}">
            <h3 class="profile_title">이름</h3>           
            <input type="text" v-model.trim="name.val"  class="input" @blur="word_e_k_n($event,'','name'),clearValidity('name')">
        </div>   
        <div class="pblock juso" :class="{invalid: !addressDetail.isValid}">
            <h3 class="profile_title">주소</h3>
            <!-- <img :src="`${require('@/assets/imgs/level/'+userInfo.level+'.png')}`"> -->
            <!-- <input type="text" name="nic" :value="`${userInfo.nic}`" class="input" v-model="user_nic"> -->
            <div class="zonecode">                 
                <input type="text" v-model.trim="zonecode.val"  
                class="input" placeholder="우편번호" readonly 
                @click="popOpen('dialog_addrSearch')"               
                >
                <div class="btn-wrapper"><base-button-sm mode="darkred" @click="popOpen('dialog_addrSearch')">우편번호찾기</base-button-sm></div>  
            </div>
            
            <input type="text" v-model.trim="roadAddress.val"  class="input" @blur="clearValidity('roadAddress')" placeholder="도로명주소" readonly @click="popOpen('dialog_addrSearch')">
            <input type="text" v-model.trim="addressDetail.val"  class="input" placeholder="상세주소" @blur="word_e_k_n($event,'','addressDetail'),clearValidity('addressDetail')">
            
        </div>   
        <div class="pblock" :class="{invalid: !phone1.isValid || !phone2.isValid || !phone3.isValid }">
            <h3 class="profile_title">휴대폰</h3> 
            <div class="column mobile">
                <div class="mobile_input_wrapper">
                    <select v-model.trim="phone1.val" @blur="clearValidity('phone1')">
                        <option value="010">010</option>                       
                    </select>   
                    <input type="text" v-model.trim="phone2.val"  class="input" @blur="word_n($event,'','phone2'),clearValidity('phone2')" maxlength="4">
                    <input type="text" v-model.trim="phone3.val" class="input" @blur="word_n($event,'','phone3'),clearValidity('phone3')" maxlength="4"> 
                </div>
                <div class="btn-wrapper">
                    <base-button-sm :mode="authMobileCaption.btn_color" @click="reqtoken('mobile')" :ckdisablde="btnMobileDisable">
                        {{authMobileCaption.button_text}}
                    </base-button-sm>
                </div>
            </div>           
           
        </div>   
        <div class="pblock" :class="{invalid: !email.isValid}">
            <h3 class="profile_title">이메일</h3>  
            <div class="column email">
                <input type="text" 
                v-model.trim="email.val"  class="input" @blur="clearValidity('email')">
                <div class="btn-wrapper">
                    <base-button-sm :mode="authEmailCaption.btn_color" @click="reqtoken('email')" :ckdisablde="btnEmailDisable">
                        {{authEmailCaption.button_text}}
                    </base-button-sm>
                </div>
            </div>             
        </div>  
        <div v-if="!formIsValid" class="alert-valid">
            <div><span class="ic_alert animate-bounce"></span></div>
            <div class="text">입력 사항을 다시 확인 해 주세요!!!</div>
        </div>
        <div v-if="!authentication.isValid" class="alert-valid">
            <div><span class="ic_alert  animate-bounce" :class="animate-ping"></span></div>
            <div class="text">휴대폰이나 이메일 인증이 필요합니다!!!</div>
        </div>
        
        <div class="caution">
            ⚡본인인증은 상품구매시 필요한 절차로 <strong>불이행시 제약</strong>이 있을 수 있습니다.
        </div>

        <div class="bottom">
            <base-button-sm mode="orange" @click="submitSelfAuth()">저장하기</base-button-sm>
        </div>


    </div>
</div>
    <base-dialog :show="dialog_ckToken.isable" title="인증번호 입력"  @close="popClose('dialog_ckToken')" :isMobile="isMobile">
        <div class="token_dialog">
            <div class="item_title">
              <h1>인증번호 확인</h1>
              <span>전달받은 인증번호를 입력해 주세요</span>
            </div>
            <div class="input_area">
                <input type="text" placeholder="" v-model.trim="token">
                <div>
                    <base-button-sm mode="skyblue" @click="confirmToken(dialog_ckToken.type)">확인</base-button-sm>    
                </div>
            </div>
        </div>
    </base-dialog>
    <base-dialog :show="dialog_addrSearch" title="주소검색"  @close="popClose('dialog_addrSearch')" :isMobile="isMobile">
        <div class="searchform"><vue-daum-postcode :options="options" @complete="onComplete"/></div>
    </base-dialog>
    
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
import { ckWord } from '@/components/mixins/ckWord.js';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { authInfo } from '@/components/mixins/authInfo.js';
export default {
    name:'selfauth',
    props:{
        isMobile:{default:false}
    },
    mixins:[auth,ckWord,authInfo],
    data() {
        return {           
            formIsValid: true,        
            authentication:{
                mobile:false,
                email:false,
                isValid:true
            },
            
            dialog_ckToken:{isable:false,type:''},
            token:'',
            dialog_addrSearch:false,
            addrResult:'',
            btnMobileDisable:false,
            btnEmailDisable:false
        }
    },
    components:{
        VueDaumPostcode           
    },
    computed:{
        authMobileCaption() {
            if (this.authentication.mobile) {
                return {button_text:"인증완료",btn_color:'disable'};
            } else if(this.btnMobileDisable) {
                return {button_text:"전송중",btn_color:'disable'};
            }else {
                return {button_text:"인증번호받기",btn_color:'skyblue'};
            }
        },
        authEmailCaption() {
            if (this.authentication.email) {
                return {button_text:"인증완료",btn_color:'disable'};
            } else if(this.btnEmailDisable) {
                return {button_text:"전송중",btn_color:'disable'};
            }else {
                return {button_text:"인증번호받기",btn_color:'skyblue'};
            }
        },        
    },
    mounted(){
        
    },
    methods:{
       
        onComplete(data) {
            
            this.zonecode.val = data.zonecode;            
            if(data.buildingName !==""){
                this.roadAddress.val = data.roadAddress+'('+data.bname+','+data.buildingName+')'; 
            }else{
                this.roadAddress.val = data.roadAddress+'('+data.bname+')';    
            }
            this.addrResult=data;
            this.zonecode.isValid = true;
            this.roadAddress.isValid = true; 
            this.popClose("dialog_addrSearch");      
        },    
        daumpostcoded(){
            this.searchpop = true;
        },      
        //인증 발송
        async reqtoken(type)
        {
            let actionPayload ="";
            if(type === "email"){
                if(this.authCheck() !==true)
                {
                    return;
                }            
                if (this.email.val === '' ||  !this.email.val.includes("@"))
                {
                    alert('이메일이 올바르지 않습니다.');
                    return;
                }
                  //인증받았거나, 전송중이면 리턴
                if(this.authentication.email || this.btnEmailDisable)
                {
                    alert('이미 인증되었거나 전송중입니다.');
                    return;
                }

                actionPayload = {
                    user_id:this.user.id,
                    email: this.email.val,                
                };
            }else{
                if(this.name.val ==='')
                {
                    alert('이름을 입력해 주세요');
                    return;
                }
                if (this.phone2.val === '' ||  this.phone3.val === '' || this.phone2.val.length !== 4 ||  this.phone3.val.length !== 4)
                {
                    alert('유효하지 않은 전화번호 입력입니다.');
                    return;
                }

                //인증받았거나, 전송중이면 리턴
                if(this.authentication.mobile || this.btnMobileDisable)
                {
                    alert('이미 인증되었거나 전송중입니다.');
                    return;
                }
                actionPayload = {
                    user_id:this.user.id,
                    name:this.name.val,
                    phone1: this.phone1.val,
                    phone2: this.phone2.val,         
                    phone3: this.phone3.val,                         
                };    
            }
            try {
                
                let response =""
                if(type === "email"){     
                    this.btnEmailDisable = true;     
                    response = await this.$store.dispatch("users/reqEmailauth", actionPayload);
                }else{
                    this.btnMobileDisable = true;
                    response = await this.$store.dispatch("users/reqMobileauth", actionPayload);   
                }
                if(response.status_code===200)
                {
                    this.dialog_ckToken.isable =true;
                }               

                this.$flashMessage.show({
                    type: response.status_code===200? "info":"error",
                    title: response.message,
                    message: response.message,
                });
                if(type === "email"){     
                    this.btnEmailDisable = false;     
                    this.dialog_ckToken.type ="email";
                }else{
                    this.btnMobileDisable = false;      
                    this.dialog_ckToken.type ="mobile";
                }
            } catch (error) {
                console.log(error.response);
                switch (error.response.status) {
                    case 422:
                        this.$flashMessage.show({
                        type: "error",
                        title: "유효하지 않은 데이터 입력입니다.",
                        message: "유효하지 않은 데이터 입력입니다.",
                        });
                        break;
                    case 401:
                        this.$flashMessage.show({
                        type: "error",
                        title: error.response.data.message,
                        message: error.response.data.message,
                        });
                        break;
                    case 500:
                        this.$flashMessage.show({
                        type: "error",
                        title: error.response.data.message,
                        message: error.response.data.message,
                        });
                        break;
                    default:
                        this.$flashMessage.show({
                        type: "error",
                        title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        });
                        break;
                }
            }
           
        },
        //인증번호 확인
        async confirmToken(type)
        {                
            //alert(type);      
            if (this.token === '')
            {
                alert('인증번호를 입력 해 주세요');
                return;
            }
            const actionPayload = {
                user_id:this.user.id,
                email: this.email.val,
                token:this.token,
                phone1:this.phone1.val,
                phone2:this.phone2.val,
                phone3:this.phone3.val,
                type:type,
            };
            try {
                           
                const response = await this.$store.dispatch("users/ckAuthToken", actionPayload);

                           
                if(response.status_code===200)
                {
                    if(response.type === 'mobile')
                    {
                        this.authentication.mobile = true;
                        this.authentication.isValid = true;
                    }

                    if(response.type === 'email')
                    {
                        this.authentication.email = true;
                        this.authentication.isValid = true;
                    }
                    
                    this.dialog_ckToken.isable =false;          
                }    
                
                this.$flashMessage.show({
                    type: response.status_code===200? "info":"error",
                    title: response.message,
                    message: response.message,
                });
            } catch (error) {
                console.log(error.response);
                switch (error.response.status) {
                    case 422:
                        this.$flashMessage.show({
                        type: "error",
                        title: "유효하지 않은 데이터 입력입니다.",
                        message: "유효하지 않은 데이터 입력입니다.",
                        });
                        break;
                    case 401:
                        this.$flashMessage.show({
                        type: "error",
                        title: error.response.data.message,
                        message: error.response.data.message,
                        });
                        break;
                    case 500:
                        this.$flashMessage.show({
                        type: "error",
                        title: error.response.data.message,
                        message: error.response.data.message,
                        });
                        break;
                    default:
                        this.$flashMessage.show({
                        type: "error",
                        title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        });
                        break;
                }
            }
        },
        clearValidity(input) {
            if(this[input].val !=='')
            {
                if(!this[input].wordValid){
                    this[input].val = "";
                    this[input].wordValid = true;
                }else{
                    this[input].isValid = true;
                }
               
            }
        },
        validateForm() {
            this.formIsValid = true;
            //이름 체크
            if (this.name.val === '' || this.name.val.length < 2 || !this.name.wordValid)
            {
                this.name.isValid = false;
                this.formIsValid = false;
            }

            //주소
            if (this.addressDetail.val === '')
            {
                this.addressDetail.isValid = false;
                this.formIsValid = false;
            }

            //휴대폰
            if (this.phone2.val === '' || !this.phone2.wordValid )
            {
                this.phone2.isValid = false;
                this.formIsValid = false;
            }
            if (this.phone3.val === '' || !this.phone3.wordValid )
            {
                this.phone3.isValid = false;
                this.formIsValid = false;
            }
            
            //이메일 체크
            if (this.email.val === '' ||  !this.email.val.includes("@"))
            {
                this.email.isValid = false;
                this.formIsValid = false;
            }  

            //인증체크
            if (!this.authentication.email && !this.authentication.mobile )
            {
                this.authentication.isValid = false;                
            }
            // if (this.agreepolicy.val.length === 0)
            // {
            //     this.agreepolicy.isValid = false;
            // }
        },  
        async submitSelfAuth()
        {
            if(this.authCheck() !==true)
            {
                return;
            }
            this.validateForm();

            if (!this.formIsValid || !this.authentication.isValid) {
                return;
            }
            const actionPayload = {
                user_id:this.user.id,
                name:this.name.val,
                zonecode:this.zonecode.val,
                roadAddress:this.roadAddress.val,
                addressDetail:this.addressDetail.val,
                phone1:this.phone1.val,
                phone2:this.phone2.val,
                phone3:this.phone3.val,
                email: this.email.val,   

            };
            try {
                           
                const response = await this.$store.dispatch("users/selfAuthStore", actionPayload);
                
                this.$flashMessage.show({
                    type: response.status_code===200? "info":"error",
                    title: response.message,
                    message: response.message,
                });
            } catch (error) {
                console.log(error.response);
                switch (error.response.status) {
                    case 422:
                        this.$flashMessage.show({
                        type: "error",
                        title: "유효하지 않은 데이터 입력입니다.",
                        message: "유효하지 않은 데이터 입력입니다.",
                        });
                        break;
                    case 401:
                        this.$flashMessage.show({
                        type: "error",
                        title: error.response.data.message,
                        message: error.response.data.message,
                        });
                        break;
                    case 500:
                        this.$flashMessage.show({
                        type: "error",
                        title: error.response.data.message,
                        message: error.response.data.message,
                        });
                        break;
                    default:
                        this.$flashMessage.show({
                        type: "error",
                        title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        });
                        break;
                }
            }
        },
        intitAuthBtn(){
            
        },
        popOpen(type){
            if(type === "dialog_ckToken")
            {
                this.dialog_ckToken.isable = true;
            }
            if(type === "dialog_addrSearch")
            {
                this.dialog_addrSearch = true;
            }    
        },
        popClose(type){
            if(type === "dialog_ckToken")
            {
                this.dialog_ckToken.isable = false;
            }
            if(type === "dialog_addrSearch")
            {
                this.dialog_addrSearch = false;
            }            
        } ,
        alert_ment(ment)
        {
            alert(ment);
        }      
    }    
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/ani_infinite";
.mobile_selfAuth{
    background: #fff;
    margin-top:-1px;
    .page_title_center{
        h1{display: none}
        span{
            width:60%;
            margin:0 auto;
            background:rgb(255, 245, 245);
            padding:5px 10px;
            border-radius: 10px;
            color:#b72e00;
        }
    }
    .self_auth{       
        width: 90%;
        margin-top:10px;
    }
    .column{
        width:100% !important;
        .btn-wrapper{
            margin-left: 5px !important;
        }
        select, input,div{
            margin:0 !important;                
        }
    }
    .juso{
        .zonecode{
            .input{
                width:60% !important;
            }
        }
        .input{
            width:90% !important;
        }
    }
    
}
.page_title_center{
    display: flex;
    flex-direction:column;
    span{
        display: inline-block;
        font-size:11px;
        color:#666;
        margin-top:10px;
    }
}
.self_auth{
    width:60%;
    margin:50px auto;
    .caution{
        margin:20px 0;
        background:#f2fdb6;
        border-radius: 10px;
        padding:10px;
    }    
   
    .alert-valid{
        margin-top:10px;
        font-size:12px;
        color:#b72e00;
        display:flex;
        justify-content: center;
        .ic_alert{
            display:inline-block;
            width:15px;
            height:15px;
            background: url(../../assets/imgs/sp_account.png) no-repeat -60px 0;
        }
        .text{padding-left:10px;}
    }  
    
    .pblock{
        margin-top:10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction:column;
        color:#666;
        .disable{
            background:#ccc;
        }
        .zonecode{
            display: flex;
            justify-content: center;
            width: 100%;
            input{
                width:60%;
            }
        }
        .preview_wrap{
            margin-bottom:20px;
            text-align:center;
            display:flex;
            justify-content: center;
            #preview{
                border:5px solid #ccc;
                width:100px;
                height:100px;
                border-radius:10px;
                cursor:pointer;
                p{
                    padding-top:20px;
                    color:#ccc;
                }
            }
        }
        .column{
            display: flex;
            width:80%;
            justify-content: space-between;
            .btn-wrapper{
                margin-left: 20px;   
                height: 31px;  
                width:25%;           
            }
        }
        .mobile{
            .mobile_input_wrapper{
                display: flex;
                justify-content: space-between;
                width:80%;
                select, input,div{
                    margin:0 10px;                
                }
                select,input{
                    border:1px solid #ccc;
                    border-radius: 5px;
                    width:30%;
                    text-align: center;
                    padding:3px 10px;                
                }
                select{
                    margin-left:0;
                }
            }            
        }
        .email{
            input{
                width:80%
            }
        }
        .input{
            font-size:14px;
            border:none;
            border-bottom:1px dotted #666;
            text-align:left;
            padding-left:20px;
            width:80%;
            line-height: 30px;
        }
    }
    .profile_title{
        text-align:left;
        width:100%;
        font-size:11px;
        color:#666;
    }
    
    .edit_profile{
        margin-top:50px;
        line-height:30px;
        button{width:20%;}
    }
    .bottom{
        display: flex;
        justify-content: center;
        margin-top:20px;
        margin-bottom:50px;
        line-height:30px;
        button{width:20%;}
    }
   
}
.token_dialog{
    text-align: center;    
    .item_title{
        span{color:rgb(148, 148, 148)}
    }
    .input_area{
        border-top:1px solid rgb(233, 233, 233);
        border-bottom:1px solid rgb(233, 233, 233);
        margin-top:10px;
        display: flex;
        justify-content: center;
        padding:20px;
        input{
            border:1px solid #ccc;
            border-radius: 5px;
            width:30%;
            text-align: center;
            padding:3px 10px;    
            line-height: 30px;            
        }
    }
}
.searchform{
    height:400px;
    overflow-y: auto;
}
</style>